import {
  ActiviteElementKey,
  CompetencesWithChefIndication,
  ElementKey,
  VehiculeMinimized,
} from "@/models";
import { Http } from "@/utils/http";

/** Read-only reference data ("référentiels") shared across the app — activity types, locations, equipment, roles. */
export default class DataService {
  /** Lists the possible activity types (Garde, DPS, Maraude, ...). */
  public static async typesActivite(): Promise<ActiviteElementKey[]> {
    const targetUrl = `${process.env.VUE_APP_API_APP}/?task=typesActivite`;
    const { data: response } = await Http.instance.get(targetUrl);
    return response.data;
  }
  /** Lists the possible "DO" (dispositif opérationnel) types. */
  public static async typesDO(): Promise<ElementKey[]> {
    const targetUrl = `${process.env.VUE_APP_API_APP}/?task=typesDO`;
    const { data: response } = await Http.instance.get(targetUrl);
    return response.data;
  }

  /** Lists the known activity locations ("lieux"). */
  public static async lieux(): Promise<ElementKey[]> {
    const targetUrl = `${process.env.VUE_APP_API_APP}/?task=lieux`;
    const { data: response } = await Http.instance.get(targetUrl);
    return response.data;
  }

  /** Lists vehicles in a minimal shape (id/label), for pickers. */
  public static async vehicules(): Promise<VehiculeMinimized[]> {
    const targetUrl = `${process.env.VUE_APP_API_APP}/?task=vehicules`;
    const { data: response } = await Http.instance.get(targetUrl);
    return response.data;
  }

  /** Lists the known equipment items ("matériels"). */
  public static async materiels(): Promise<ElementKey[]> {
    const targetUrl = `${process.env.VUE_APP_API_APP}/?task=materiels`;
    const { data: response } = await Http.instance.get(targetUrl);
    return response.data;
  }

  /**
   * Lists competences, optionally scoped to a given activity type.
   * @param typeActiviteId When provided, filters to competences relevant to this activity type.
   */
  public static async competences(
    typeActiviteId?: string
  ): Promise<CompetencesWithChefIndication[]> {
    const targetUrl = `${process.env.VUE_APP_API_APP}/?task=competences${
      typeActiviteId ? `&type=${typeActiviteId}` : ""
    }`;
    const { data: response } = await Http.instance.get(targetUrl);
    return response.data;
  }

  /** Lists the assignable user roles. */
  public static async roles(): Promise<ElementKey[]> {
    const targetUrl = `${process.env.VUE_APP_API_APP}/?task=roles`;
    const { data: response } = await Http.instance.get(targetUrl);
    return response.data;
  }
}
